<template>

  <ss-modal
    v-show="isModalVisible"
    title="Opłata za monit"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <p class="h6 mt-0 mb-1">Opłata za monit</p>
      <p class="mt-0 mb-1">Nr wezwania: <strong class="text-primary bold">{{ reminder.reminder_number }}</strong></p>
      <p class="my-0">Kwota z tytułu wystawienia: <strong class="text-primary bold">{{ toNumber(reminder.penalty_amount) }} zł</strong></p>
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body">
      <div>
        <span>Wybierz datę płatności:</span>
        <ss-date
          placeholder="Data wpłaty"
          v-model="paymentDate"
          class="mt-1" />
      </div>

      <div class="mt-4">
        <span class="d-block mb-2">Wybierz wpłatę:</span>
        <div class="card card-small">
          <div class="card-body p-0 pb-3 text-center">
            <d-alert
              v-if="loadError"
              show
              theme="warning"
              class="mt-4">
              Wczytywanie danych nie powiodło się.
              <a
                  href="javascript:window.location.reload();"
                  class="alert-link">
                  Odśwież stronę
              </a>
              aby spróbować ponownie.
            </d-alert>
            <table
              v-else
              class="table mb-0 responsive-table">
              <div
                v-if="!loaded"
                class="overlay-loading">
                <h2 class="preloader isLoading">Trwa ładowanie</h2>
              </div>
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Data wpłaty</th>
                  <th scope="col" class="border-0">Kwota płatności</th>
                  <th scope="col" class="border-0" style="">Akcje</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(payment, index) in payment_history"
                  :key="payment.id"
                  :class="{'table-success': installmentID === payment.id}">
                  <td>
                    <dt>Data wpłaty</dt>
                    <dd>
                      {{ payment.paid_date }}
                    </dd>
                  </td>
                  <td>
                    <dt>Kwota płatności</dt>
                    <dd>
                      {{ toNumber(payment.amount) }} zł
                    </dd>
                  </td>
                  <td>
                    <dt>Akcje</dt>
                    <dd>
                      <d-button
                        :disabled="installmentID === payment.id"
                        @click.prevent="installmentID = payment.id">
                        {{ installmentID === payment.id ? 'Wybrano' : 'Wybierz' }}
                      </d-button>
                    </dd>
                  </td>
                </tr>
                <tr v-if="!payment_history.length">
                  <td
                    colspan="4"
                    class="text-center text-info">
                    Brak płatności do wyświetlenia.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Anuluj
      </d-button>
      <d-button
        :disabled="!paymentDate || !installmentID"
        @click.prevent="setAsPaid"
        :class="{
          'ml-3': true,
          'isLoading': actionInProgress
        }"
        theme="success">
        <i class="material-icons">check</i> Potwierdź
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal'
import SsDate from '@/components/common/SsDate';
import ListUtils from '@/utils/ListUtils.js';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'SettleReminderPaymentModal',
  components: {
    SsModal,
    SsDate
  },
  props: {
    isModalVisible: {
      default: false,
      type: Boolean
    },
    reminder: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      actionInProgress: false,
      installmentID: null,
      loaded: false,
      loadError: false,
      payment_history: [],
      paymentDate: null
    }
  },
  mounted () {
    this.loadPaymentsData();
  },
  methods: {
    loadPaymentsData () {
      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/get-payment-history',
        listField: 'payment_history',
        pagination: false,
        params: {
          client_id: this.$route.params.client_id,
          schedule_id: this.$route.params.schedule_id,
          date_from: this.reminder.reminder_date
        }
      });
    },
    setAsPaid () {
      this.actionInProgress = true;

      FormUtils.submitWithConfirm(this, {
        endpoint: '/api/contract-reminders/change-reminder-status/' + this.reminder.id,
        formData: {
          paid_date: this.paymentDate,
          installment_id: this.installmentID
        },
        successTitle: 'Status został zmieniony na opłacone.',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy na pewno chcesz zmienić status wezwania na opłacone?',
        confirmButtonText: 'Tak',
        errorTitle: 'Wystapił błąd',
        errorText: 'Zmiana statusu nie powiodła się Spróbuj ponownie.',
        successAction: () => {
          this.actionInProgress = false;
          this.$bus.$emit('contract-reload-reminders');
          this.$bus.$emit('reload-contract');
          this.closeModal(true);
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    closeModal (shouldReload = false) {
      this.$bus.$emit('settle-payment-modal-close', shouldReload);
    },
    toNumber (number) {
      return Vue.toNumber(number);
    }
  }
}
</script>
